import React from 'react';
import { cn } from '../utils/cn';

const STATUS_TONE = {
  // Order statuses
  PENDING_PAYMENT: 'warning',
  PAID: 'info',
  ASSIGNED: 'brand',
  IN_PROGRESS: 'warning',
  COMPLETED: 'success',
  CANCELLED: 'neutral',
  // Payment statuses
  PENDING: 'warning',
  FAILED: 'danger',
  REFUNDED: 'neutral',
  // Report statuses
  READY: 'success',
  AMENDED: 'info',
  ARCHIVED: 'neutral'
};

function pretty(s = '') {
  return String(s).replaceAll('_', ' ');
}

function StatusBadge({ status, tone, children }) {
  const t = tone || STATUS_TONE[status] || 'neutral';
  return (
    <span className={cn('badge', t)}>
      <span className="dot" />
      {children || pretty(status)}
    </span>
  );
}

export default StatusBadge;
